import { CONFIG } from 'Config/config'

export const roleOptions = {
  [CONFIG.USER_ROLE.ADMIN]: {
    label: 'Administrator',
    value: CONFIG.USER_ROLE.ADMIN,
  },
  [CONFIG.USER_ROLE.CITY_MANAGER]: {
    label: 'City Manager',
    value: CONFIG.USER_ROLE.CITY_MANAGER,
  },
  [CONFIG.USER_ROLE.CLIENT_ADMIN]: {
    label: 'Client Admin',
    value: CONFIG.USER_ROLE.CLIENT_ADMIN,
  },
  [CONFIG.USER_ROLE.CLIENT]: {
    label: 'Client',
    value: CONFIG.USER_ROLE.CLIENT,
  },
  [CONFIG.USER_ROLE.RECRUITER]: {
    label: 'Recruiter',
    value: CONFIG.USER_ROLE.RECRUITER,
  },
}

export const getReadableRoleByUser = user => {
  if (
    user.subrole === CONFIG.SUBROLES.ASSISTANT &&
    user.role === CONFIG.USER_ROLE.CITY_MANAGER
  ) {
    return CONFIG.USER_SUBROLE.CITY_MANAGER_ASSISTANT
  }
  return user.role
}
